import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import PageLoader from './components/PageLoader';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="RegionalMetros"
      components={[
        { override: 'NoRoute', component: PageLoader('error_404') },
        { override: 'Index', component: PageLoader('the_elliott_conservancy') },
      ]}
      routes={[
        { name: 'contact-us', exact: true, path: '/contact-us', component: PageLoader('contact_us'), sitemapIgnore: true },
        { name: 'privacy-policy', exact: true, path: '/privacy-policy', component: PageLoader('privacy_policy'), sitemapIgnore: true },
        { name: 'terms', exact: true, path: '/terms', component: PageLoader('terms'), sitemapIgnore: true },
        { name: 'accessibility', exact: true, path: '/accessibility', component: PageLoader('accessibility'), sitemapIgnore: true },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js